import { createRouter, createWebHistory } from 'vue-router';
import Dashboard from '../views/Dashboard.vue';
import History from '../views/History.vue';
import Approvals from '../views/Approvals.vue';
import ApprovalDetail from '../views/ApprovalDetail.vue';
import MyApprovals from '../views/MyApprovals.vue';
import Login from '../components/Login.vue';
import AdminPanel from '../components/AdminPanel.vue';
import Statistics from '@/components/Statistics.vue';
import Settlement from '@/components/Settlement.vue';
import Reports from '@/components/Reports.vue';
import PrivacyPolicy from '../views/PrivacyPolicy.vue';

const routes = [
  { path: '/', component: Login, name: 'Login' },
  { path: '/privacy-policy', component: PrivacyPolicy, name: 'PrivacyPolicy' },
  { path: '/dashboard', component: Dashboard, meta: { requiresAuth: true }, name: 'Dashboard' },
  { path: '/history', component: History, meta: { requiresAuth: true }, name: 'History' },
  { path: '/approvals', component: Approvals, meta: { requiresAuth: true, requiresApprover: true }, name: 'Approvals' },
  { path: '/approvals/:id', component: ApprovalDetail, meta: { requiresAuth: true, requiresApprover: true }, name: 'ApprovalDetail' },
  { path: '/my-approvals', component: MyApprovals, meta: { requiresAuth: true, requiresApprover: true }, name: 'MyApprovals' },
  { path: '/admin', component: AdminPanel, meta: { requiresAuth: true, requiresAdmin: true }, name: 'Admin' },
  { path: '/stats', component: Statistics, meta: { requiresAuth: true, requiresAdmin: false }, name: 'Statistics' },
  { path: '/settlement', component: Settlement, meta: { requiresAuth: true, requiresFinance: true }, name: 'Settlement' },
  { path: '/reports', component: Reports, meta: { requiresAuth: true, requiresManagement: true }, name: 'Reports' },
  { path: '/request/:id', component: ApprovalDetail, meta: { requiresAuth: true }, name: 'RequestDetail' },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  if (to.meta.requiresAuth && !token) {
    next({ name: 'Login' });
  } else if (to.meta.requiresAdmin && user.role !== 'admin') {
    next({ name: 'Dashboard' });
  } else if (to.meta.requiresApprover && user.role === 'employee') {
    next({ name: 'Dashboard' });
  } else if (to.meta.requiresFinance && user.role !== 'finance') {
    next({ name: 'Dashboard' });
  } else if (to.meta.requiresManagement && !['finance', 'managing_director', 'ceo', 'admin'].includes(user.role)) {
    next({ name: 'Dashboard' });
  } else {
    next();
  }
});

export default router;